<template>
  <div>
    <ResultBox />
    <div style="margin-top: 30px;">
      <a href="https://xosoredcross.com/" title="XOSO Redcross" target="_blank">
        <img src="/assets/images/redcross550x450.png" style="max-width: 100%;">
      </a>
    </div>
  </div>
</template>
<script>
import ResultBox from './components/ResultBox.vue'

export default {
  components: {
    ResultBox
  },
  data() {
    return {
      currentDate: null
    }
  },
  computed: {
    src() {
      return '//www.minhngoc.net.vn/ket-qua-xo-so/'+ this.$route.params.pathDate +'.html'
    }
  }
}
</script>
<style lang="scss">
.my-result {
  height: 450px;
  margin-bottom: 10px;
}
.iframe-box {
  overflow: hidden;
}
#iframe-l {
  overflow: hidden;
  height: 5720px !important;
  margin-left: -210px;
  margin-top: -180px;
  width: 740px;
  max-width: none;
}
</style>
